import { Redirect } from 'react-router-dom'
import { client } from '../../hooks/Client'

const Subscription = () => <Redirect to={`/${client}/Settings/7`} />

export default Subscription
